import * as z from 'zod';

import { contactQueryLinkerSchema } from '@/_pages/contacts/shared';
import { fileQuerySchema } from '@/_schemas/file';
import { booleanFormSchema } from '@/_schemas/generic';

import { pickTicketsQuerySchema } from './pick-tickets-query-schema';

import { deliveryMethodFormSchema } from '../components/delivery-method';
import { removalCauseFormSchema } from '../components/removal-cause';
import { statusFormSchema } from '../components/status';
import { pickTicketsItemFormSchema } from '../pick-ticket-items-schemas';

export const pickTicketsFormSchema = pickTicketsQuerySchema
  .omit({ client_id: true, picked_at: true })
  .extend({
    attached_documents: z.array(fileQuerySchema),
    notes: z.string(),
    why_removed: removalCauseFormSchema.nullable(),
    why_removed_comment: z.string(),
    status: statusFormSchema.nullable(),
    delivery_method: deliveryMethodFormSchema.nullable(),
    tracking_number: z.string(),
    remove_items: booleanFormSchema(),
    pick_ticket_items: z.array(pickTicketsItemFormSchema),
    contacts: contactQueryLinkerSchema.nullable(),
  })
  .refine(({ remove_items, why_removed }) => !(!!remove_items && !why_removed), {
    message: 'Why removed is required',
    path: ['why_removed'],
  });

export type PickTicketsFormSchema = z.infer<typeof pickTicketsFormSchema>;
